
import Header from '@/components/partials/Header';
import Features from '@/components/partials/landing/Features';
import BackgroundGray from '@/components/helpers/BackgroundGray';
import LastSearches from '@/components/partials/landing/LastSearches';
import Card from '@/components/helpers/Card';
import Money from '@/components/helpers/Money';
import CardContent from '@/components/helpers/Card/CardContent';
import PreFooter from '@/components/partials/PreFooter';
import Footer from '@/components/partials/Footer';
import PhotoCredits from "@/components/partials/PhotoCredits";
import Breadcrumbs from "@/components/partials/Breadcrumbs.vue";
import Title from "@/components/style/Title.vue";
import ListSearches from "@/components/partials/ListSearches.vue";

export default {
  components: {
    ListSearches,
    Title,
    Breadcrumbs,
    PhotoCredits,
    Footer,
    PreFooter,
    CardContent,
    Money,
    LastSearches,
    Card,
    BackgroundGray,
    Features,
    Header
  },

  data() {
    return {
      breadcrumbs: [],
      searches: [],
      aircompaniesCalendar: [],
      airportsCalendar: [],
      page: null,
      url: null,
      links_other: [],
      links_related: []
    };
  },

  nuxtI18n: {
    paths: {
      'it': '/compagnia-aerea-:aircompany',
      'ro': '/compania-aeriana-:aircompany',
      'en': '/air-company-:aircompany',
      'ru': '/aviakompaniya-:aircompany',
      'pl': '/linia-lotnicza-:aircompany',
      'de': '/fluggesellschaft-:aircompany',
      'es': '/aerolinea-:aircompany',
      'pt': '/cia-aerea-:aircompany',
      'hu': '/legitarsasag-:aircompany',
      'fi': '/lentoyhtio-:aircompany',
      'sv': '/flygbolag-:aircompany',
      'da': '/flyselskab-:aircompany',
      'fr': '/compagnie-aerienne-:aircompany'
    }
  },

  methods: {},

  async fetch() {
    const page = await this.$api.contents.query({
      multiple: false,
      type: 'aircompany',
      slug: this.$route.params.aircompany
    }).then((res) => {
      return res.data.content;
    })
    this.page = page;

    const searches = await this.$api.flightCalendar.query({
      aircompany: this.page.custom_data.aircompany.code,
      limit: 10
    }).then((res) => {
      return res.data;
    })
    this.searches = searches.calendars;
    this.aircompaniesCalendar = searches.aircompanies;
    this.airportsCalendar = searches.airports;

    // return;

    this.$store.commit('seo/setTitle', this.page.seo.title);
    this.$store.commit('seo/setDescription', this.page.seo.description);
    this.$store.commit('seo/setKeywords', this.page.seo.keywords);
    this.$store.commit('seo/setImage', this.page.image + '?format=jpg');

    this.breadcrumbs.push({
      text: this.$t('home.Home'),
      to: {
        name: 'index'
      }
    });

    this.breadcrumbs.push({
      text: this.$t('seo.Airlines'),
      to: {
        name: 'aircompanies'
      }
    });

    this.breadcrumbs.push({
      text: this.$t('seo-aircompany.Title', {aircompany: this.page.custom_data.aircompany.name}),
      to: {
        name: 'aircompany',
        params: {
          destination: this.page.slug
        }
      }
    });

    // Fix content adding dynamic links
    let part = [];
    if (typeof this.page.custom_data.destination !== 'undefined') {
      this.page.custom_data.destination.forEach((destination) => {
        if (destination.links['flights-to']) {
          part.push('<a href="' + this.localePath({
            name: 'flights-to-destination',
            params: {destination: destination.slug}
          }) + '">' + destination.city_name + '</a>');
        } else {
          part.push(destination.city_name);
        }
      });
      let partText = part.join(', ');
      this.page.content.content = this.page.content.content.replaceAll('{list_destinations}', partText);
    }

    return;

    await this.$store.commit('seo/setDescription', this.$t('seo-aircompany.Seo Description', {
      aircompany: this.page.custom_data.aircompany.name
    }));

    let alternatives = {};
    this.$i18n.localeCodes.forEach(function (code) {
      alternatives[code] = {};
      alternatives[code].aircompany = page.custom_data.aircompany.slug;
    });
    await this.$store.dispatch('i18n/setRouteParams', alternatives);

    let seeder = this.$helpers.stringToNumberSeed(this.page.code);
    // Destinations
    let otherDestinations = await this.$api.internal.get('summary/flights-to')
        .then(response => {
          return response.data;
        });
    otherDestinations = this.$helpers.shuffleSeeder(otherDestinations, seeder);
    this.links_other = this._.slice(otherDestinations, 0, 15);

    // Routes
    let routes = await this.$api.internal.get('summary/flights-routes')
        .then(response => {
          return response.data;
        });

    routes = this.$helpers.shuffleSeeder(routes, seeder);

    let routesRelated = [];

    for (let i = 0; i < routes.length; i++) {
      let index1 = i;
      let index2 = ++i;
      if (routes[index1] && routes[index2]) {
        routesRelated.push({
          departure: {
            slug: routes[index1].slug,
            name: routes[index1].name
          },
          destination: {
            slug: routes[index2].slug,
            name: routes[index2].name
          }
        });
      }
    }
    this.links_related = this._.slice(routesRelated, 0, 15);

    console.log(this.$i18n.localeProperties.code);

    if (this.$i18n.localeProperties.code === 'ro-md') {
      await this.$store.commit('seo/setCanonical', 'https://www.ninjatrip.ro' + this.localeRoute({
        name: 'aircompany-aircompany',
        params: {
          aircompany: this.page.custom_data.aircompany.slug
        }
      }, 'ro-ro').fullPath);
    } else {
      await this.$store.commit('seo/setCanonical', this.localeRoute({
        name: 'aircompany-aircompany',
        params: {
          aircompany: this.page.custom_data.aircompany.slug
        }
      }).fullPath);
    }

    // Other
    if (1 === 2 && this.page.custom_data.min_price) {
      await this.$store.commit('seo/setTitle', this.$t('seo-aircompany.Seo Title with Price', {
        min_price: this.$currency(this.page.custom_data.min_price,
            this.$i18n.localeProperties.currency, false),
        aircompany: this.page.custom_data.aircompany.name
      }));
    } else {
      await this.$store.commit('seo/setTitle', this.$t('seo-aircompany.Seo Title', {
        aircompany: this.page.custom_data.aircompany.name
      }));
    }
  }
};
